import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
import './legacy-hero.css';
import './scroll-choreography.css';
import './footer.css';
import './asset-loading.css';
import './team-story.css';
import './commerce.css';
import './admin-content.css';
import './product-cards.css';
import './pro-content-enhancements.css';
import './content-overrides.css';
import './admin/pro-admin.css';
import './contact-admin-fixes.css';
import App from './App';
import { CartProvider } from './context/CartContext';
import { CommerceProvider } from './context/CommerceContext';

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <CommerceProvider><CartProvider><App /></CartProvider></CommerceProvider>
  </BrowserRouter>
);
